// 第1张
const imgAll1 = {
    JP: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1723604901153/Frame%201000008958.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1723606077393/solar%E5%85%85%E7%94%B5.jpg',
    },
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724644109380/c2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1724644109178/d2.jpg',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725153965379/euPC2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725153965022/euH2.jpg',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725160635026/ukPC2.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1725160504592/ukH2.jpg',
    },
};
const imgLocale1: any = {
    jp: imgAll1.JP,
    us: imgAll1.NA,
    ca: imgAll1.NA,
    br: imgAll1.NA,
    mx: imgAll1.NA,
    uk: imgAll1.UK,
    eu: imgAll1.EU,
    de: imgAll1.EU,
    fr: imgAll1.EU,
    it: imgAll1.EU,
    es: imgAll1.EU,
};
export default imgLocale1;
